export default __webpack_public_path__ + "830f648facf7809a1021e55d1e83702f.ttf";